import React, { Component } from 'react';
import {observer} from 'mobx-react';
import styles from '../index.css';
import fonts from '../../../../iconfonts.css';
import DropItem from '../DropItem/index';
import {presets} from '../../../stores/index';


@observer
export default class ChooseEquip extends Component {

    state={limit: this.props.limit - presets[this.props.elem].reduce((sum, current)=>{
         if(current.name !=="Хопер"){return sum + current.quantity};
         return sum
    }, 0)};

    render() {
        return (
            <div className={styles.chooseEquipment}>
                <h3>{this.props.data.title}</h3>
                <div className={styles.equipTableHeading}>
                    <div className={styles.equipRow}>
                        <div className={styles.columnEquipName}>Оборудование</div>
                        <div className={styles.columnCrops}>{this.props.data.desc}</div>
                        <div className={styles.columnPrice}>Цена ($)</div>
                        <div className={styles.columnQuantity}>Количество</div>
                    </div>
                    <div className={styles.equipRow}>
                        <div className={styles.columnEquipName} />
                        <div className={styles.columnCrops}>
                            <div className={styles.cultureCircle + ' ' + styles.wheat}><i className={fonts.wheat}/></div>
                            <div className={styles.cultureCircle + ' ' + styles.rape}><i className={fonts.rape}/></div>
                            <div className={styles.cultureCircle + ' ' + styles.soy}><i className={fonts.soy}/></div>
                            <div className={styles.cultureCircle + ' ' + styles.sunflower}><i className={fonts.sunflower}/></div>
                            <div className={styles.cultureCircle + ' ' + styles.corn}><i className={fonts.corn}/></div>
                        </div>
                        <div className={styles.columnPrice} />
                        <div className={styles.columnQuantity} />
                    </div>
                </div>
                <div className={styles.scrollableItems}>
                    <div className={styles.equipList}>
                        {presets[this.props.elem].map((item,i)=><DropItem id={i} {...item} func={(quantity)=>{
                            if(this.props.elem === 'storageEquip' && presets[this.props.elem][i].name === "Хопер"){
                                if(item.quantity + quantity <= 4){
                                    item.quantity+=quantity;
                                }
                            }else{
                            if(quantity<=this.state.limit && (this.state.limit - this.props.limit-quantity <= 0) ) {
                                item.quantity += quantity;
                                this.setState({limit: this.state.limit - quantity});
                                if (this.props.refer) {
                                    presets.setCulturePlan();
                                }
                            }
                        }}} key={i}/>
                        )}
                    </div>
                </div>
                <div className={styles.elementCounter}>Доступно элементов: {this.state.limit}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/shared/components/EquipComponents/ChooseEquip/index.js